import { Card, Spin, Typography } from 'antd';
import { useQuery } from '../../../hooks/useQuery';
import { useVerifyPatientTokenQuery } from '../../../services/patientsApi';
import { ReactComponent as SmileySVG } from '../../../assets/images/smiley.svg';
import { SubmitTreatmentCheckInForm } from './submit-treatment-check-ins-form/submit-treatment-check-ins-form';

const { Text } = Typography;

const PatientTreatmentCheckIn = () => {
  const query = useQuery();
  const token = query.get('token');
  const checkInNumber = query.get('checkInNumber');
  const { data, isLoading, isError } = useVerifyPatientTokenQuery(token!, {
    skip: !token,
    refetchOnMountOrArgChange: true,
  });

  if (isLoading) {
    return (
      <div className="h-screen w-screen flex flex-column align-items-center justify-content-center">
        <div>
          <Spin />
        </div>
        <div>
          <Text>Loading...</Text>
        </div>
      </div>
    );
  }

  if (isError) {
    return (
      <div className="success">
        <Card style={{ maxWidth: 500 }} bordered={false} className="mx-4">
          <div className="text-center my-4">
            <SmileySVG />
          </div>
          <div className="success-message-container">
            <span className="title text-center" style={{ color: '#102e51' }}>
              You’ve already checked in using this link
            </span>
            <div className="half-border" />
            <p className="mt-3 expired-content">
              We generate a unique link for every treatment check in. Please check your email or text messages to use
              the latest link
            </p>
          </div>
        </Card>
      </div>
    );
  }

  if (data && !isLoading && checkInNumber && token) {
    return <SubmitTreatmentCheckInForm token={token} checkInNumber={checkInNumber} checkInData={data} />;
  }

  return null;
};

export default PatientTreatmentCheckIn;
